(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('present-list-product', {
            parent: 'entity',
            url: '/present-list-product?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentListProduct.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list-product/present-list-products.html',
                    controller: 'PresentListProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentListProduct');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('present-list-product-detail', {
            parent: 'entity',
            url: '/present-list-product/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentListProduct.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list-product/present-list-product-detail.html',
                    controller: 'PresentListProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentListProduct');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PresentListProduct', function($stateParams, PresentListProduct) {
                    return PresentListProduct.get({id : $stateParams.id});
                }]
            }
        })
        .state('present-list-product.new', {
            parent: 'present-list-product',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list-product/present-list-product-dialog.html',
                    controller: 'PresentListProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('present-list-product', null, { reload: true });
                }, function() {
                    $state.go('present-list-product');
                });
            }]
        })
        .state('present-list-product.edit', {
            parent: 'present-list-product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list-product/present-list-product-dialog.html',
                    controller: 'PresentListProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PresentListProduct', function(PresentListProduct) {
                            return PresentListProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('present-list-product.delete', {
            parent: 'present-list-product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list-product/present-list-product-delete-dialog.html',
                    controller: 'PresentListProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PresentListProduct', function(PresentListProduct) {
                            return PresentListProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
